import { createReducer, on } from "@ngrx/store";
import { IEmployeeReport } from "src/app/shared/interfaces/employee-report/iemployeereport";
import { EmployeeReportActions } from "./employee-report.actions";


export interface IEmployeeReportState {
    employee_report: IEmployeeReport;
}

const initialState: IEmployeeReportState = {
    employee_report: {
        agendamento_funcionario: [
            {
                posicao_ranking: 1,
                foto: null,
                nome_funcionario: "Amanda Gomes",
                nome_unidade: "Coração Eucarístico",
                retornos: "12",
                pagos: "100"
            },
            {
                posicao_ranking: 2,
                foto: null,
                nome_funcionario: "Rodrigo Silva",
                nome_unidade: "Vila Nova",
                retornos: "10",
                pagos: "84"
            },
            {
                posicao_ranking: 3,
                foto: null,
                nome_funcionario: "Fernanda Araujo",
                nome_unidade: "Coração Eucarístico",
                retornos: "9",
                pagos: "78"
            },
            {
                posicao_ranking: 4,
                foto: null,
                nome_funcionario: "Carlos Augusto",
                nome_unidade: "Vila Nova",
                retornos: "9",
                pagos: "65"
            }
        ],
        avaliacoes_antes_de_tres_horas: [
            {
                posicao_ranking: 1,
                foto: null,
                nome_funcionario: "Amanda Gomes",
                porcentagem: "92%"
            },
            {
                posicao_ranking: 2,
                foto: null,
                nome_funcionario: "Rodrigo Silva",
                porcentagem: "89%"
            },
            {
                posicao_ranking: 3,
                foto: null,
                nome_funcionario: "Fernanda Araujo",
                porcentagem: "87%"
            },
            {
                posicao_ranking: 4,
                foto: null,
                nome_funcionario: "Carlos Augusto",
                porcentagem: "82%"
            }
        ],
        entrega_de_exames: [
            {
                posicao_ranking: 1,
                nome_unidade: "Vila Nova",
                total_entregas: "88",
                entregas_por_funcionario: [
                    {
                        nome_funcionario: "Rodrigo Silva",
                        total_entregas_do_funcionario: "32"
                    },
                    {
                        nome_funcionario: "Amanda Gomes",
                        total_entregas_do_funcionario: "25"
                    },
                    {
                        nome_funcionario: "Carlos Augusto",
                        total_entregas_do_funcionario: "14"
                    }
                ]
            },
            {
                posicao_ranking: 2,
                nome_unidade: "Belo Horizonte",
                total_entregas: "74",
                entregas_por_funcionario: [
                    {
                        nome_funcionario: "Rodrigo Silva",
                        total_entregas_do_funcionario: "32"
                    },
                    {
                        nome_funcionario: "Amanda Gomes",
                        total_entregas_do_funcionario: "25"
                    },
                    {
                        nome_funcionario: "Carlos Augusto",
                        total_entregas_do_funcionario: "14"
                    }
                ]
            },
            {
                posicao_ranking: 3,
                nome_unidade: "Barreiro",
                total_entregas: "71",
                entregas_por_funcionario: [
                    {
                        nome_funcionario: "Rodrigo Silva",
                        total_entregas_do_funcionario: "32"
                    },
                    {
                        nome_funcionario: "Amanda Gomes",
                        total_entregas_do_funcionario: "25"
                    },
                    {
                        nome_funcionario: "Carlos Augusto",
                        total_entregas_do_funcionario: "14"
                    }
                ]
            },
            {
                posicao_ranking: 4,
                nome_unidade: "Uberlândia",
                total_entregas: "56",
                entregas_por_funcionario: [
                    {
                        nome_funcionario: "Rodrigo Silva",
                        total_entregas_do_funcionario: "32"
                    },
                    {
                        nome_funcionario: "Amanda Gomes",
                        total_entregas_do_funcionario: "25"
                    },
                    {
                        nome_funcionario: "Carlos Augusto",
                        total_entregas_do_funcionario: "14"
                    }
                ]
            }
        ],
        media_resolucoes_enviadas: [
            {
                posicao_ranking: 1,
                nome_unidade: "Coração Eucarístico",
                media_total_resolucoes: 0.5,
                total_resolucoes: "134",
                resolucoes_por_funcionario: [
                    {
                        nome_funcionario: "Rodrigo Silva",
                        qtd_resolucoes: "54"
                    },
                    {
                        nome_funcionario: "Amanda Gomes",
                        qtd_resolucoes: "42"
                    },
                    {
                        nome_funcionario: "Carlos Augusto",
                        qtd_resolucoes: "38"
                    }
                ]
            },
            {
                posicao_ranking: 2,
                nome_unidade: "Belo Horizonte",
                media_total_resolucoes: 1,
                total_resolucoes: "134",
                resolucoes_por_funcionario: [
                    {
                        nome_funcionario: "Rodrigo Silva",
                        qtd_resolucoes: "54"
                    },
                    {
                        nome_funcionario: "Amanda Gomes",
                        qtd_resolucoes: "42"
                    },
                    {
                        nome_funcionario: "Carlos Augusto",
                        qtd_resolucoes: "38"
                    }
                ]
            },
            {
                posicao_ranking: 3,
                nome_unidade: "Vila Nova",
                media_total_resolucoes: 1,
                total_resolucoes: "134",
                resolucoes_por_funcionario: [
                    {
                        nome_funcionario: "Rodrigo Silva",
                        qtd_resolucoes: "54"
                    },
                    {
                        nome_funcionario: "Amanda Gomes",
                        qtd_resolucoes: "42"
                    },
                    {
                        nome_funcionario: "Carlos Augusto",
                        qtd_resolucoes: "38"
                    }
                ]
            },
            {
                posicao_ranking: 4,
                nome_unidade: "Uberlândia",
                media_total_resolucoes: 2,
                total_resolucoes: "134",
                resolucoes_por_funcionario: [
                    {
                        nome_funcionario: "Rodrigo Silva",
                        qtd_resolucoes: "54"
                    },
                    {
                        nome_funcionario: "Amanda Gomes",
                        qtd_resolucoes: "42"
                    },
                    {
                        nome_funcionario: "Carlos Augusto",
                        qtd_resolucoes: "38"
                    }
                ]
            }
        ],
        relatorio_por_funcionario: [
            {
                posicao_ranking: 1,
                nome_funcionario: "Alexandre Lucio",
                agendamentos_feitos: "204",
                avaliacoes_enviadas: "145",
                exames_entregues: "73",
                solicitacoes_finalizadas: "102"
            },
            {
                posicao_ranking: 2,
                nome_funcionario: "Antônio Carlos",
                agendamentos_feitos: "204",
                avaliacoes_enviadas: "145",
                exames_entregues: "73",
                solicitacoes_finalizadas: "102"
            },
            {
                posicao_ranking: 3,
                nome_funcionario: "Augusto Santos",
                agendamentos_feitos: "204",
                avaliacoes_enviadas: "145",
                exames_entregues: "73",
                solicitacoes_finalizadas: "102"
            },
            {
                posicao_ranking: 4,
                nome_funcionario: "Antônio Carlos",
                agendamentos_feitos: "204",
                avaliacoes_enviadas: "145",
                exames_entregues: "73",
                solicitacoes_finalizadas: "102"
            },
            {
                posicao_ranking: 5,
                nome_funcionario: "Alexandre Lucio",
                agendamentos_feitos: "204",
                avaliacoes_enviadas: "145",
                exames_entregues: "73",
                solicitacoes_finalizadas: "102"
            },
            {
                posicao_ranking: 6,
                nome_funcionario: "Antônio Carlos",
                agendamentos_feitos: "204",
                avaliacoes_enviadas: "145",
                exames_entregues: "73",
                solicitacoes_finalizadas: "102"
            },
            {
                posicao_ranking: 7,
                nome_funcionario: "Augusto Santos",
                agendamentos_feitos: "204",
                avaliacoes_enviadas: "145",
                exames_entregues: "73",
                solicitacoes_finalizadas: "102"
            },
            {
                posicao_ranking: 8,
                nome_funcionario: "Antônio Carlos",
                agendamentos_feitos: "204",
                avaliacoes_enviadas: "145",
                exames_entregues: "73",
                solicitacoes_finalizadas: "102"
            }
        ],
        total_relatorio_por_funcionario: {
            agendamentos_feitos: "204",
            avaliacoes_enviadas: "145",
            exames_entregues: "73",
            solicitacoes_finalizadas: "102"
        }
    }
}

export const employeeReportReducer = createReducer(
    initialState,
    on(
        EmployeeReportActions.loadEmployeeReportSuccess,
        (state, { employee_report }) => ({
            ...state,
            employee_report: employee_report
        })
    )

);